'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function uniqWith(arr, areItemsEqual) {
    var _loop = function(i) {
        var item = arr[i];
        var isUniq = result.every(function(v) {
            return !areItemsEqual(v, item);
        });
        if (isUniq) {
            result.push(item);
        }
    };
    var result = [];
    for(var i = 0; i < arr.length; i++)_loop(i);
    return result;
}
exports.uniqWith = uniqWith;
